<template>
  <span>
    <i :class="statusList[status].icon"></i> {{ statusList[status].description }}
  </span>
</template>

<script>

  import CertComplementRequestService from "@/services/cert-complement-request-service"

  export default {

    data() {
      return {
        statusList: CertComplementRequestService.STATUS,
      }
    },

    props: ["status"], 

  }
</script>